<div class="h-[calc(100vh)]">
  <router-outlet />
</div>
